import React from 'react';
import _ from 'lodash';
import { styled } from '@mui/material/styles';
import Loading from 'components/Loading';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import ScheduledDashboardEmailItem from './ScheduledDashboardEmailItem';
import { ScheduledDashboardEmail } from '../types';

type Props = {
    className?: string;
    emailList: ScheduledDashboardEmail[] | undefined;
    onDeleteScheduleConfig: (arg1: number) => void;
    isLoading: boolean;
    listTitle: string;
    noSchedule: string;
    onEditScheduleConfig?: (arg1: number) => void;
};

const ScheduledDashboardEmailListWrapper = styled(Box, {
    name: 'ScheduledDashboardEmailListWrapper',
})({
    paddingTop: '10px',
    marginTop: '10px',
});

const ScheduledDashboardEmailList = ({
    className = '',
    emailList,
    isLoading,
    onDeleteScheduleConfig,
    listTitle,
    noSchedule,
    onEditScheduleConfig = undefined,
}: Props): React.ReactElement => {
    return (
        <ScheduledDashboardEmailListWrapper className={className}>
            <Typography variant="h5" sx={{ mb: '20px' }}>
                {listTitle}
            </Typography>
            {isLoading && <Loading />}
            {!isLoading && emailList?.length === 0 && (
                <Typography className="mui-no-schedule">
                    {noSchedule}
                </Typography>
            )}
            {emailList &&
                emailList.length !== 0 &&
                emailList.map((email) => (
                    <ScheduledDashboardEmailItem
                        key={email.id}
                        email={email}
                        onDeleteScheduleConfig={onDeleteScheduleConfig}
                        onEditScheduleConfig={onEditScheduleConfig}
                    />
                ))}
        </ScheduledDashboardEmailListWrapper>
    );
};

export default ScheduledDashboardEmailList;
